/* logic-trainer-app.js — DOM/flow for /logic-trainer.
 * Pure-logic lives in logic-trainer-engine.js; rendering in logic-trainer-icons.js.
 * This file: screens (home/practice/daily/diagnostic/report), per-skill rendering &
 * input, gentle feedback, TTS narration, gamification, progress persistence, telemetry. */
(function () {
  'use strict';
  var E = window.LogicTrainerEngine, IC = window.LogicTrainerIcons;
  var LT = window.__LT || { T: {}, cfg: {} };
  var CFG = LT.cfg || {};
  var SLUG = CFG.slug || 'logic-trainer';
  var LOCALE = (window.__LOCALE || CFG.locale || 'en').toLowerCase();
  var BCP47 = { en: 'en-US', ru: 'ru-RU', ko: 'ko-KR', ar: 'ar-SA', id: 'id-ID', pt: 'pt-BR', de: 'de-DE', es: 'es-ES', fr: 'fr-FR', uk: 'uk-UA', tr: 'tr-TR' }[LOCALE] || 'en-US';
  var ROOT = document.getElementById('ltApp');
  if (!ROOT || !E || !IC) { return; }

  // ── i18n: walk the nested translation object with a dot path; interpolate :vars ──
  function t(path, vars) {
    var cur = LT.T, parts = String(path).split('.');
    for (var i = 0; i < parts.length; i++) { if (cur == null) break; cur = cur[parts[i]]; }
    if (cur == null) return path;
    if (typeof cur === 'string' && vars) cur = cur.replace(/:(\w+)/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    return cur;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function vocab(dim, val) {
    var key = dim === 'size' ? 'vocab.size.' + (val === 1 ? 'small' : val === 3 ? 'big' : 'medium') : 'vocab.' + dim + '.' + val;
    var s = t(key); return s === key ? String(val) : s;
  }

  // ── telemetry (allowed event types only) ──
  function ae(type, payload) { try { if (window.__ae) window.__ae(type, payload || {}); } catch (e) { } }
  var funnelMarks = {};
  function funnel(step, extra) { if (funnelMarks[step]) return; funnelMarks[step] = 1; var p = { tool_slug: SLUG, step: step }; if (extra) for (var k in extra) p[k] = extra[k]; ae('tool_funnel', p); }
  try { if (window.Timbrica3D && window.Timbrica3D.init) window.Timbrica3D.init(SLUG); } catch (e) { }

  // ── narration ──
  // Site-wide rule: NO sound autoplay. Narration only ever fires from an explicit
  // tap (the 🔊 buttons, force=true) unless the user has opted into auto-narrate in
  // Settings (default OFF). Never speak on page load / home / puzzle render by itself.
  var ttsOn = false;
  // force=true → an explicit tap on the 🔊 button: speak even if auto-narrate is off.
  function say(text, force) {
    if (!text || (!ttsOn && !force)) return;
    try {
      if (window.TTSHelper && window.TTSHelper.isSupported()) window.TTSHelper.speak(text, { lang: BCP47, rate: ST.settings.voiceRate || 0.92, pitch: 1.08 });
      else if (window.speechSynthesis && window.SpeechSynthesisUtterance) { var u = new SpeechSynthesisUtterance(text); u.lang = BCP47; u.rate = ST.settings.voiceRate || 0.92; u.pitch = 1.08; window.speechSynthesis.cancel(); window.speechSynthesis.speak(u); }
    } catch (e) { }
  }
  function announce(msg) { try { if (window.__announce) window.__announce(msg); } catch (e) { } }
  function hasTTS() { try { return !!(window.TTSHelper && window.TTSHelper.isSupported()); } catch (e) { return false; } }

  // ── state (single versioned localStorage doc) ──
  var TS = window.__toolSettings || { save: function () { }, load: function (a, b, c) { return c; } };
  var ST;            // active child's state doc — all gameplay code reads/writes this
  var PROF;          // wrapper: { v:2, activeId, profiles:[{id,name,avatar,doc}] }
  var AVATARS = ['🦊', '🐱', '🐼', '🐸', '🦁', '🦄', '🐶', '🐰', '🐻', '🐯', '🐵', '🦉'];
  function defaultState() {
    var skills = {};
    for (var i = 0; i < E.SKILLS.length; i++) skills[E.SKILLS[i]] = E.newSkillState(1);
    return { v: 1, age: null, settings: { autoNarrate: false, sound: true, parent: false, dys: false, voiceRate: 0.92 }, skills: skills, journey: { totalCorrect: 0, setsDone: 0, badges: [] }, diagnostic: { done: false } };
  }
  function migrateDoc(raw) {
    raw = raw || {}; var d = defaultState();
    raw.settings = Object.assign(d.settings, raw.settings || {});
    raw.journey = Object.assign(d.journey, raw.journey || {});
    if (!raw.skills) raw.skills = d.skills;
    for (var i = 0; i < E.SKILLS.length; i++) if (!raw.skills[E.SKILLS[i]]) raw.skills[E.SKILLS[i]] = E.newSkillState(1);
    if (raw.age === undefined) raw.age = null;
    if (!raw.diagnostic) raw.diagnostic = { done: false };
    // One-time: kill auto-narrate for docs saved before the no-autoplay change, so
    // returning visitors stop getting voice on load. Re-enabling stays a click in Settings.
    if (!raw._noAuto) { raw.settings.autoNarrate = false; raw._noAuto = 1; }
    raw.v = 1; return raw;
  }
  function newProfile(name, avatar) {
    return { id: 'c' + Math.floor(Math.random() * 1e9).toString(36) + (Math.floor(Math.random() * 1e6).toString(36)), name: (name || '').slice(0, 20), avatar: avatar || AVATARS[0], doc: defaultState() };
  }
  function loadProfiles() {
    var raw = TS.load(SLUG, 'state', null);
    if (raw && raw.v === 2 && raw.profiles && raw.profiles.length) {
      raw.profiles.forEach(function (p) { p.doc = migrateDoc(p.doc); });
      if (!raw.profiles.some(function (p) { return p.id === raw.activeId; })) raw.activeId = raw.profiles[0].id;
      return raw;
    }
    var wrap = { v: 2, activeId: null, profiles: [] };
    var p = newProfile('', AVATARS[0]);
    if (raw && typeof raw === 'object' && raw.skills) p.doc = migrateDoc(raw); // migrate old single-doc v1
    wrap.profiles.push(p); wrap.activeId = p.id;
    return wrap;
  }
  function activeProfile() { for (var i = 0; i < PROF.profiles.length; i++) if (PROF.profiles[i].id === PROF.activeId) return PROF.profiles[i]; return PROF.profiles[0]; }
  function saveState() { try { var p = activeProfile(); if (p) p.doc = ST; PROF.updatedAt = Date.now(); TS.save(SLUG, 'state', PROF); syncPush(); } catch (e) { } }

  // ── Pro cross-device sync (optional; whole-PROF last-write-wins on a device clock) ──
  function isProUser() { try { return document.body && document.body.getAttribute('data-pro') === '1'; } catch (e) { return false; } }
  function deviceId() { try { var d = localStorage.getItem('lt_device'); if (!d) { d = 'd' + Math.floor(Math.random() * 1e9).toString(36) + Date.now().toString(36); localStorage.setItem('lt_device', d); } return d; } catch (e) { return 'd0'; } }
  function ajaxUrl() { return location.pathname.replace(/\/+$/, '').replace(/\/ajax$/, '') + '/ajax'; }
  function csrfTok() { var m = document.querySelector('meta[name="csrf-token"]'); return m ? m.getAttribute('content') : ''; }
  function syncPost(payload) {
    return fetch(ajaxUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfTok(), 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(payload) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  var syncTimer = null;
  function syncPush() {
    if (!isProUser()) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncPost({ action: 'sync', client_id: deviceId(), document: JSON.stringify(PROF), client_updated_at: PROF.updatedAt || 0 }); }, 2000);
  }
  function adoptRemote(docStr) {
    try { var doc = JSON.parse(docStr); if (!doc || !doc.profiles) return false; doc.profiles.forEach(function (p) { p.doc = migrateDoc(p.doc); }); PROF = doc; ST = activeProfile().doc; ttsOn = ST.settings.autoNarrate; applyDys(); TS.save(SLUG, 'state', PROF); return true; } catch (e) { return false; }
  }
  function syncPull() {
    if (!isProUser()) return;
    syncPost({ action: 'pull' }).then(function (res) {
      if (!res || !res.ok || !res.document) { syncPush(); return; }       // nothing on server → push local
      if ((+res.client_updated_at || 0) > (PROF.updatedAt || 0)) { if (adoptRemote(res.document)) renderHome(); } // server newer → adopt
      else { syncPush(); }                                                  // local newer/equal → push
    });
  }
  function switchProfile(id) { PROF.activeId = id; ST = activeProfile().doc; ttsOn = ST.settings.autoNarrate; applyDys(); saveState(); renderHome(); }
  function addProfile(name, avatar) { var p = newProfile(name, avatar); PROF.profiles.push(p); PROF.activeId = p.id; ST = p.doc; ttsOn = ST.settings.autoNarrate; saveState(); }
  function deleteProfile(id) { if (PROF.profiles.length <= 1) return; PROF.profiles = PROF.profiles.filter(function (p) { return p.id !== id; }); if (PROF.activeId === id) { PROF.activeId = PROF.profiles[0].id; ST = activeProfile().doc; } saveState(); }

  // ── gentle sound effects (WebAudio, no assets — RU-safe; respects the sound setting) ──
  var _ac = null;
  function audioCtx() { try { if (!_ac) _ac = new (window.AudioContext || window.webkitAudioContext)(); if (_ac.state === 'suspended') _ac.resume(); return _ac; } catch (e) { return null; } }
  function tone(ac, freq, start, dur, type, gain) {
    var o = ac.createOscillator(), g = ac.createGain();
    o.type = type || 'sine'; o.frequency.value = freq;
    g.gain.setValueAtTime(0, ac.currentTime + start);
    g.gain.linearRampToValueAtTime(gain || 0.12, ac.currentTime + start + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + start + dur);
    o.connect(g); g.connect(ac.destination);
    o.start(ac.currentTime + start); o.stop(ac.currentTime + start + dur + 0.02);
  }
  function playSound(kind) {
    if (!ST.settings.sound) return;
    var ac = audioCtx(); if (!ac) return;
    try {
      if (kind === 'correct') { tone(ac, 660, 0, 0.12, 'sine'); tone(ac, 880, 0.1, 0.16, 'sine'); }
      else if (kind === 'wrong') { tone(ac, 240, 0, 0.18, 'triangle', 0.09); }
      else if (kind === 'levelup') { tone(ac, 660, 0, 0.1); tone(ac, 880, 0.09, 0.1); tone(ac, 1175, 0.18, 0.2); }
      else if (kind === 'win') { [523, 659, 784, 1046].forEach(function (f, i) { tone(ac, f, i * 0.12, 0.18); }); }
    } catch (e) { }
  }

  // ── tiny DOM helpers ──
  function h(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstElementChild; }
  function show(node) { ROOT.innerHTML = ''; ROOT.appendChild(node); }
  function seed() { return (Math.floor(Math.random() * 0x7fffffff)) >>> 0; }
  var SKILL_EMOJI = { patterns: '🔁', oddone: '🔍', sort: '🗂️', analogy: '🔗', spatial: '🧭', deduce: '🕵️', quantity: '⚖️', memory: '🧠' };
  var BADGE_EMOJI = { first: '⭐', keen: '🔥', master: '🏆', explorer: '🧭', star: '🌟' };

  // ════════════════════════════ HOME / SKILL MAP ════════════════════════════
  function renderHome() {
    curPuzzle = null;
    if (keyHandler) { document.removeEventListener('keydown', keyHandler); keyHandler = null; }
    var tiles = '';
    for (var i = 0; i < E.SKILLS.length; i++) {
      var sk = E.SKILLS[i], st = ST.skills[sk];
      var stars = '';
      for (var s = 0; s < 3; s++) stars += '<span class="lt-star ' + (s < st.stars ? 'on' : '') + '">★</span>';
      tiles += '<button class="lt-tile lg-card" data-skill="' + sk + '">'
        + '<span class="lt-tile-emoji">' + SKILL_EMOJI[sk] + '</span>'
        + '<span class="lt-tile-name">' + esc(t('skill.' + sk + '.name')) + '</span>'
        + '<span class="lt-stars">' + stars + '</span>'
        + '<span class="lt-prog"><span style="width:' + st.mastery + '%"></span></span>'
        + '</button>';
    }
    var diagBtn = ST.diagnostic.done
      ? '<button class="lt-btn lt-btn-ghost" id="ltDiag">📋 ' + esc(t('ui.see_report')) + '</button>'
      : '<button class="lt-btn lt-btn-primary" id="ltDiag">📋 ' + esc(t('ui.start_diagnostic')) + '</button>';
    // Achievements strip — earned badges are colourful, locked ones greyed (a goal to chase).
    var earned = ST.journey.badges || [];
    var badges = ['first', 'keen', 'master', 'explorer', 'star'].map(function (b) {
      return '<span class="lt-badge ' + (earned.indexOf(b) >= 0 ? 'on' : '') + '" title="' + b + '">' + (BADGE_EMOJI[b] || '🏅') + '</span>';
    }).join('');
    var ap = activeProfile();
    var node = h(
      '<div class="lt-home">'
      + '<div class="lt-profbar"><button class="lt-prof-chip" id="ltProf" aria-label="' + esc(t('ui.profile_switch_title')) + '"><span class="lt-prof-av">' + esc(ap.avatar) + '</span><span class="lt-prof-name">' + esc(ap.name || t('ui.player')) + '</span><span class="lt-prof-caret" aria-hidden="true">▾</span></button></div>'
      + '<div class="lt-actions">'
      + diagBtn
      + '<button class="lt-btn" id="ltDaily">⭐ ' + esc(t('ui.daily')) + '</button>'
      + (hasTTS() ? '<button class="lt-btn lt-btn-ghost" id="ltListen" aria-label="' + esc(t('ui.listen')) + '">🔊 ' + esc(t('ui.listen')) + '</button>' : '')
      + '</div>'
      + '<h2 class="lt-h2">' + esc(t('ui.your_skills')) + '</h2>'
      + '<div class="lt-tiles">' + tiles + '</div>'
      + '<div class="lt-badges"><h2 class="lt-h2">' + esc(t('ui.badges_title')) + '</h2><div class="lt-badges-row">' + badges + '</div></div>'
      + '<div class="lt-foot-actions"><button class="lt-link" id="ltWorksheet">🖨️ ' + esc(t('ui.ws_title')) + '</button> &nbsp; <button class="lt-link" id="ltSettings">⚙️ ' + esc(t('ui.settings')) + '</button></div>'
      + '</div>');
    node.querySelectorAll('.lt-tile').forEach(function (b) { b.addEventListener('click', function () { startPractice(b.getAttribute('data-skill')); }); });
    node.querySelector('#ltProf').addEventListener('click', openProfiles);
    node.querySelector('#ltDiag').addEventListener('click', function () { ST.diagnostic.done ? renderReport() : startDiagnostic(); });
    node.querySelector('#ltDaily').addEventListener('click', startDaily);
    var lst = node.querySelector('#ltListen'); if (lst) lst.addEventListener('click', function () { say(t('ui.welcome_say'), true); });
    node.querySelector('#ltWorksheet').addEventListener('click', openWorksheet);
    node.querySelector('#ltSettings').addEventListener('click', openSettings);
    show(node);
    funnel('home');
  }

  // Tracks the puzzle currently on screen so we can emit tool_abandon if the child
  // leaves mid-set (a key drop-off signal). Cleared on home / completion screens.
  var curPuzzle = null, curMode = 'practice', keyHandler = null;

  // ════════════════════════════ PUZZLE VIEW ════════════════════════════
  // Renders any spec + wires input; calls onDone('solved_unaided'|'solved_hinted'|'failed').
  function showPuzzle(spec, header, onDone) {
    var tries = 0, hintShown = false, done = false;
    curPuzzle = { skill: spec.skill, level: spec.level, mode: curMode, answered: (curPuzzle ? curPuzzle.answered : 0) };
    function finish(outcome) { if (curPuzzle) curPuzzle.answered++; onDone(outcome); }
    try { if (/[?&]debug=1/.test(location.search)) window.__ltDebug = { skill: spec.skill, level: spec.level, responseKind: spec.responseKind, answer: spec.answer }; } catch (e) { }
    var promptText = t(spec.promptKey, appPromptVars(spec));
    var wrap = h('<div class="lt-puzzle-wrap">'
      + header
      + '<div class="lt-prompt"><button class="lt-listen" aria-label="' + esc(t('ui.listen')) + '">🔊</button><span class="lt-prompt-txt">' + esc(promptText) + '</span></div>'
      + '<div class="lt-stage" id="ltStage"></div>'
      + '<div class="lt-feedback" id="ltFb" aria-live="polite"></div>'
      + '<div class="lt-controls"><button class="lt-btn lt-btn-ghost" id="ltHint">💡 ' + esc(t('ui.hint')) + '</button>'
      + '<button class="lt-btn lt-btn-ghost" id="ltParent">👨‍👩‍👧 ' + esc(t('ui.parent_panel')) + '</button>'
      + '<button class="lt-btn lt-btn-ghost" id="ltQuit" aria-label="' + esc(t('ui.back')) + '">✕</button></div>'
      + '<div class="lt-coach lg-card" id="ltCoach" hidden></div>'
      + '</div>');
    var stage = wrap.querySelector('#ltStage');
    var fb = wrap.querySelector('#ltFb');
    var api = renderStage(stage, spec, submit);
    wrap.querySelector('.lt-listen').addEventListener('click', function () { say(promptText, true); });
    wrap.querySelector('#ltHint').addEventListener('click', function () { giveHint(); });
    wrap.querySelector('#ltParent').addEventListener('click', function () { toggleCoach(wrap.querySelector('#ltCoach'), spec); });
    wrap.querySelector('#ltQuit').addEventListener('click', function () { try { window.TTSHelper && window.TTSHelper.cancel(); } catch (e) { } renderHome(); });
    if (ST.settings.parent) toggleCoach(wrap.querySelector('#ltCoach'), spec, true);
    show(wrap);
    // Keyboard: digit keys 1–9 pick an option (older kids / desktop / accessibility).
    if (keyHandler) document.removeEventListener('keydown', keyHandler);
    keyHandler = function (e) {
      if (e.metaKey || e.ctrlKey || e.altKey || done) return;
      var opts = wrap.querySelectorAll('.lt-opt'); if (!opts.length) return;
      var n = parseInt(window.__keyLetter ? window.__keyLetter(e) : e.key, 10);
      if (n >= 1 && n <= opts.length) { e.preventDefault(); opts[n - 1].click(); }
    };
    document.addEventListener('keydown', keyHandler);
    if (ST.settings.autoNarrate) setTimeout(function () { say(promptText); }, 250);

    function giveHint() {
      if (done) return;
      hintShown = true;
      var hk = spec.hintKey, hv = spec.hintVars ? { attr: vocab2(spec.hintVars.attr) } : null;
      fb.className = 'lt-feedback lt-hint'; fb.textContent = '💡 ' + t(hk, hv);
      say(t(hk, hv));
      if (api.hint) api.hint();
      ae('tool_interact', { tool_slug: SLUG, action: 'hint', skill: spec.skill, level: spec.level });
    }
    function submit(correct, complete) {
      if (done) return;
      if (complete === false) return; // multi-step not yet complete
      if (correct) {
        done = true;
        fb.className = 'lt-feedback lt-good'; fb.textContent = '✓ ' + t('ui.well_done');
        announce(t('ui.well_done')); say(t('ui.correct_say'));
        if (api.markCorrect) api.markCorrect();
        confetti(wrap); playSound('correct');
        var outcome = hintShown ? 'solved_hinted' : 'solved_unaided';
        ae('feature_use', { tool_slug: SLUG, kind: 'puzzle_solved', skill: spec.skill, level: spec.level, attempts: tries + 1, hint_used: hintShown ? 1 : 0 });
        setTimeout(function () { finish(outcome); }, 950);
      } else {
        tries++;
        if (api.markWrong) api.markWrong();
        if (tries >= 2) {
          done = true;
          fb.className = 'lt-feedback lt-reveal'; fb.textContent = t('ui.lets_see');
          say(t('ui.lets_try_together'));
          if (api.reveal) api.reveal();
          setTimeout(function () { finish('failed'); }, 1800);
        } else {
          fb.className = 'lt-feedback lt-soft'; fb.textContent = t('ui.try_again');
          say(t('ui.try_again_say')); playSound('wrong');
          if (!hintShown) giveHint();
        }
      }
    }
  }
  function vocab2(attr) { var s = t('vocab.attr.' + attr); return s === 'vocab.attr.' + attr ? attr : s; }

  function toggleCoach(box, spec, force) {
    if (force) box.hidden = false; else box.hidden = !box.hidden;
    if (box.hidden) return;
    var sk = spec.skill;
    var asks = t('coach.' + sk + '.ask'); if (!Array.isArray(asks)) asks = [String(asks)];
    var lis = asks.map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('');
    box.innerHTML = '<div class="lt-coach-h">👨‍👩‍👧 ' + esc(t('ui.for_parent')) + '</div>'
      + '<div class="lt-coach-why">' + esc(t('why.' + sk)) + '</div>'
      + '<ul class="lt-coach-ask">' + lis + '</ul>'
      + '<div class="lt-coach-watch">👀 ' + esc(t('coach.' + sk + '.watch')) + '</div>'
      + '<div class="lt-coach-life">🏠 ' + esc(t('coach.' + sk + '.life')) + '</div>';
  }

  // ── stage renderers per stimulus kind; return {hint?,markCorrect?,markWrong?,reveal?} ──
  function optionTiles(opts, onPick, px) {
    var wrap = document.createElement('div'); wrap.className = 'lt-options';
    opts.forEach(function (el, i) {
      var b = document.createElement('button'); b.className = 'lt-opt lg-card'; b.setAttribute('data-i', i);
      b.innerHTML = IC.renderEl(el, { px: px || 72, ariaLabel: describe(el) });
      b.addEventListener('click', function () { onPick(i, b); });
      wrap.appendChild(b);
    });
    return wrap;
  }
  function describe(el) {
    if (!el || el.cells) return t('ui.shape'); if (el.icon) return el.icon;
    var parts = []; if (el.color) parts.push(vocab('color', el.color)); if (el.shape) parts.push(vocab('shape', el.shape));
    return parts.join(' ') || t('ui.shape');
  }
  // Render a SINGLE attribute neutrally so the other dimensions are not implied:
  // colour → a colour swatch; shape/size → a grey shape. Used by clues, sort bins,
  // and find-target so a "shape rule" is never shown in a misleading colour.
  function renderAttr(dim, value, px) {
    px = px || 40;
    if (dim === 'color') return IC.swatch(value, px);
    if (dim === 'size') return IC.oneShape('circle', 'neutral', 'solid', Math.round(px * (value === 1 ? 0.62 : value === 3 ? 1 : 0.82)), 0);
    return IC.oneShape(value, 'neutral', 'solid', px, 0);
  }
  function targetEl(tg) { var e = { shape: 'circle', color: 'blue', size: 2, fill: 'solid' }; e[tg.d0] = tg.v0; if (tg.d1) e[tg.d1] = tg.v1; return e; }
  function describeTarget(tg) {
    var a = {}; a[tg.d0] = tg.v0; if (tg.d1) a[tg.d1] = tg.v1;
    var parts = [];
    if (a.color) parts.push(vocab('color', a.color));
    if (a.size) parts.push(vocab('size', a.size));
    if (a.shape) parts.push(vocab('shape', a.shape));
    return parts.join(' ');
  }
  // Localised prompt variables the language-agnostic engine cannot build itself.
  function appPromptVars(spec) {
    var v = {};
    if (spec.hintVars && spec.hintVars.attr) v.attr = vocab2(spec.hintVars.attr);
    if (spec.skill === 'memory' && spec.stimulus.target) v.thing = describeTarget(spec.stimulus.target);
    return v;
  }
  function rowOf(items, px) {
    var r = document.createElement('div'); r.className = 'lt-row';
    items.forEach(function (el) { var c = document.createElement('span'); c.className = 'lt-cell'; c.innerHTML = IC.renderEl(el, { px: px || 60, ariaLabel: describe(el) }); r.appendChild(c); });
    return r;
  }

  function renderStage(stage, spec, submit) {
    var kind = spec.stimulus.kind;
    if (kind === 'sequence') return stageSequence(stage, spec, submit);
    if (kind === 'set') return stageSet(stage, spec, submit);            // oddone
    if (kind === 'analogy') return stageAnalogy(stage, spec, submit);
    if (kind === 'spatial') return stageSpatial(stage, spec, submit);
    if (kind === 'compare') return stageCompare(stage, spec, submit);
    if (kind === 'order') return stageOrder(stage, spec, submit);
    if (kind === 'transitive') return stageTransitive(stage, spec, submit);
    if (kind === 'deduce') return stageDeduce(stage, spec, submit);
    if (kind === 'sort') return stageSort(stage, spec, submit);
    if (kind === 'memory_find') return stageFind(stage, spec, submit);
    if (kind === 'memory_flash') return stageFlash(stage, spec, submit);
    return {};
  }

  function stageSequence(stage, spec, submit) {
    var row = rowOf(spec.stimulus.items, 58);
    var hole = document.createElement('span'); hole.className = 'lt-cell lt-hole'; hole.textContent = '?';
    row.appendChild(hole);
    stage.appendChild(row);
    var api = singleSelectApi2(spec, submit);
    var tiles = optionTiles(spec.options, api.pick); stage.appendChild(tiles); api.tiles = tiles;
    return api;
  }
  // single-select wired against an options tile container created after
  function singleSelectApi2(spec, submit) {
    var locked = false, self = {};
    self.pick = function (i, b) {
      if (locked) return;
      if (i === spec.answer) { locked = true; b.classList.add('lt-correct'); submit(true); }
      else { b.classList.add('lt-wrong'); setTimeout(function () { b.classList.remove('lt-wrong'); }, 600); submit(false); }
    };
    self.reveal = function () { if (self.tiles) self.tiles.querySelectorAll('.lt-opt')[spec.answer].classList.add('lt-correct'); };
    self.hint = function () { if (self.tiles) { var ts = self.tiles.querySelectorAll('.lt-opt'); ts.forEach(function (x) { x.classList.add('lt-dim'); }); ts[spec.answer].classList.remove('lt-dim'); ts[spec.answer].classList.add('lt-focus'); setTimeout(function () { ts.forEach(function (x) { x.classList.remove('lt-dim'); x.classList.remove('lt-focus'); }); }, 1400); } };
    return self;
  }

  function stageSet(stage, spec, submit) { // oddone: tiles ARE items
    var api = singleSelectApi2(spec, submit);
    var tiles = optionTiles(spec.options, api.pick, 70); stage.appendChild(tiles); api.tiles = tiles;
    return api;
  }

  function stageAnalogy(stage, spec, submit) {
    var st = spec.stimulus;
    var top = document.createElement('div'); top.className = 'lt-analogy';
    top.innerHTML = '<span class="lt-cell">' + IC.renderEl(st.a, { px: 56 }) + '</span><span class="lt-arrow">→</span>'
      + '<span class="lt-cell">' + IC.renderEl(st.b, { px: 56 }) + '</span>'
      + '<span class="lt-aneq">::</span>'
      + '<span class="lt-cell">' + IC.renderEl(st.c, { px: 56 }) + '</span><span class="lt-arrow">→</span>'
      + '<span class="lt-cell lt-hole">?</span>';
    stage.appendChild(top);
    var api = singleSelectApi2(spec, submit);
    var tiles = optionTiles(spec.options, api.pick); stage.appendChild(tiles); api.tiles = tiles;
    return api;
  }

  function stageSpatial(stage, spec, submit) {
    var st = spec.stimulus;
    if (st.mode === 'grid') {
      var g = document.createElement('div'); g.className = 'lt-matrix';
      for (var r = 0; r < 2; r++) for (var c = 0; c < 2; c++) {
        var cell = st.matrix[r][c];
        var d = document.createElement('div'); d.className = 'lt-mcell';
        d.innerHTML = cell ? IC.renderEl(cell, { px: 58 }) : '<span class="lt-hole">?</span>';
        g.appendChild(d);
      }
      stage.appendChild(g);
    } else {
      var prompt = document.createElement('div'); prompt.className = 'lt-base';
      prompt.innerHTML = '<span class="lt-cell lt-base-cell">' + IC.renderEl(st.base, { px: 76 }) + '</span>';
      stage.appendChild(prompt);
    }
    var api = singleSelectApi2(spec, submit);
    var tiles = optionTiles(spec.options, api.pick); stage.appendChild(tiles); api.tiles = tiles;
    return api;
  }

  function stageCompare(stage, spec, submit) {
    var api = singleSelectApi2(spec, submit);
    var wrap = document.createElement('div'); wrap.className = 'lt-options lt-compare';
    spec.options.forEach(function (el, i) {
      var b = document.createElement('button'); b.className = 'lt-opt lg-card lt-group'; b.setAttribute('data-i', i);
      b.innerHTML = IC.renderEl(el, { px: 130, ariaLabel: el.count + '' });
      b.addEventListener('click', function () { api.pick(i, b); });
      wrap.appendChild(b);
    });
    stage.appendChild(wrap); api.tiles = wrap;
    return api;
  }

  function stageTransitive(stage, spec, submit) {
    var st = spec.stimulus;
    var clues = document.createElement('div'); clues.className = 'lt-clues';
    st.clues.forEach(function (cl) {
      var row = document.createElement('div'); row.className = 'lt-clue';
      row.innerHTML = IC.renderEl(st.entities[cl[0]], { px: 40 }) + '<span class="lt-gt">&gt;</span>' + IC.renderEl(st.entities[cl[1]], { px: 40 });
      clues.appendChild(row);
    });
    stage.appendChild(clues);
    var api = singleSelectApi2(spec, submit);
    var tiles = optionTiles(spec.options, api.pick, 60); stage.appendChild(tiles); api.tiles = tiles;
    return api;
  }

  function renderClue(cl) {
    if (cl.type === 'is' || cl.type === 'isnot') {
      return '<span class="lt-clue ' + (cl.type === 'isnot' ? 'lt-not' : '') + '">' + (cl.type === 'isnot' ? '🚫' : '✓') + renderAttr(cl.dim, cl.value, 38) + '</span>';
    }
    return '<span class="lt-clue">' + (cl.type === 'bigger' ? '⬆️' : '⬇️') + renderAttr('size', cl.value, 36) + '</span>';
  }
  function stageDeduce(stage, spec, submit) {
    var clues = document.createElement('div'); clues.className = 'lt-clues';
    spec.stimulus.clues.forEach(function (cl) { clues.innerHTML += renderClue(cl); });
    stage.appendChild(clues);
    var api = singleSelectApi2(spec, submit);
    var tiles = optionTiles(spec.options, api.pick, 56); stage.appendChild(tiles); api.tiles = tiles;
    return api;
  }

  // ── multi-step: order ──
  function stageOrder(stage, spec, submit) {
    var picked = [];
    var row = document.createElement('div'); row.className = 'lt-options lt-orderrow';
    var btns = spec.stimulus.items.map(function (el, i) {
      var b = document.createElement('button'); b.className = 'lt-opt lg-card'; b.setAttribute('data-i', i);
      b.innerHTML = '<span class="lt-ordnum"></span>' + IC.renderEl(el, { px: 64, ariaLabel: describe(el) });
      b.addEventListener('click', function () {
        if (b.classList.contains('lt-picked')) return;
        b.classList.add('lt-picked'); picked.push(i); b.querySelector('.lt-ordnum').textContent = picked.length;
        if (picked.length === spec.stimulus.items.length) {
          var ok = E.check(spec, picked).correct; submit(ok, true);
          if (!ok) { picked = []; }
        }
      });
      return b;
    });
    btns.forEach(function (b) { row.appendChild(b); });
    stage.appendChild(row);
    return {
      markWrong: function () { btns.forEach(function (b) { b.classList.remove('lt-picked'); b.querySelector('.lt-ordnum').textContent = ''; }); },
      reveal: function () { var order = spec.answer; btns.forEach(function (b) { b.classList.remove('lt-picked'); }); order.forEach(function (idx, k) { btns[idx].classList.add('lt-correct'); btns[idx].querySelector('.lt-ordnum').textContent = k + 1; }); },
      hint: function () { btns[spec.answer[0]].classList.add('lt-focus'); setTimeout(function () { btns[spec.answer[0]].classList.remove('lt-focus'); }, 1400); }
    };
  }

  // ── multi-step: sort (tap item, tap bin) ──
  function stageSort(stage, spec, submit) {
    var bins = spec.stimulus.bins, items = spec.stimulus.items, assign = {}, sel = -1;
    var itemRow = document.createElement('div'); itemRow.className = 'lt-options lt-sortitems';
    var binRow = document.createElement('div'); binRow.className = 'lt-bins';
    var binPalette = ['#0072B2', '#D55E00', '#009E73', '#9B5FB0'];
    var itemBtns = items.map(function (el, i) {
      var b = document.createElement('button'); b.className = 'lt-opt lg-card'; b.setAttribute('data-i', i);
      b.innerHTML = IC.renderEl(el, { px: 56, ariaLabel: describe(el) });
      b.addEventListener('click', function () { itemBtns.forEach(function (x) { x.classList.remove('lt-sel'); }); b.classList.add('lt-sel'); sel = i; });
      return b;
    });
    itemBtns.forEach(function (b) { itemRow.appendChild(b); });
    bins.forEach(function (bin, bi) {
      var rep = { shape: 'circle', color: 'blue', size: 2, fill: 'solid' };
      for (var d = 0; d < bin.dims.length; d++) rep[bin.dims[d]] = bin.values[d];
      // 1-attribute bin → neutral single attribute (no misleading colour/shape);
      // 2-attribute bin → the literal colour+shape (both ARE the rule).
      var label = bin.dims.length === 1 ? renderAttr(bin.dims[0], bin.values[0], 42) : IC.renderEl(rep, { px: 42 });
      var box = document.createElement('button'); box.className = 'lt-bin lg-card'; box.style.borderColor = binPalette[bi % 4];
      box.innerHTML = '<span class="lt-bin-label">' + label + '</span><span class="lt-bin-slot" data-bin="' + bi + '"></span>';
      box.addEventListener('click', function () {
        if (sel < 0) return;
        assign[sel] = bi;
        var moved = itemBtns[sel]; moved.style.opacity = '0.35'; moved.classList.remove('lt-sel');
        box.querySelector('.lt-bin-slot').appendChild(badge(sel, binPalette[bi % 4]));
        sel = -1;
        if (Object.keys(assign).length === items.length) { var ok = E.check(spec, assign).correct; submit(ok, true); if (!ok) { } }
      });
      binRow.appendChild(box);
    });
    function badge(i, color) { var s = document.createElement('span'); s.className = 'lt-binbadge'; s.style.background = color; s.innerHTML = IC.renderEl(items[i], { px: 26 }); return s; }
    var hintBar = h('<div class="lt-hintbar">' + esc(t('ui.sort_help')) + '</div>');
    stage.appendChild(hintBar); stage.appendChild(itemRow); stage.appendChild(binRow);
    return {
      markWrong: function () { },
      reveal: function () { /* show correct by colour */ items.forEach(function (el, i) { itemBtns[i].style.opacity = '1'; }); },
      hint: function () { itemBtns.forEach(function (b) { b.classList.remove('lt-sel'); }); if (itemBtns[0]) itemBtns[0].classList.add('lt-focus'); setTimeout(function () { if (itemBtns[0]) itemBtns[0].classList.remove('lt-focus'); }, 1200); }
    };
  }

  // ── multi-step: memory find (toggle select all targets) ──
  function stageFind(stage, spec, submit) {
    var chosen = {};
    var tg = spec.stimulus.target;
    var chip = h('<div class="lt-target"><span class="lt-target-lbl">' + esc(t('ui.find_all')) + '</span>'
      + (tg.d1 ? IC.renderEl(targetEl(tg), { px: 48 }) : renderAttr(tg.d0, tg.v0, 48)) + '</div>');
    stage.appendChild(chip);
    var tiles = optionTiles(spec.stimulus.items, function (i, b) {
      if (chosen[i]) { delete chosen[i]; b.classList.remove('lt-sel'); } else { chosen[i] = 1; b.classList.add('lt-sel'); }
    }, 64);
    stage.appendChild(tiles);
    var bar = h('<div class="lt-controls"><button class="lt-btn lt-btn-primary" id="ltCheck">' + esc(t('ui.check')) + '</button></div>');
    bar.querySelector('#ltCheck').addEventListener('click', function () {
      var resp = Object.keys(chosen).map(Number).sort(function (a, b) { return a - b; });
      submit(E.check(spec, resp).correct, true);
    });
    stage.appendChild(bar);
    return {
      markWrong: function () { },
      reveal: function () { var ts = tiles.querySelectorAll('.lt-opt'); spec.answer.forEach(function (i) { ts[i].classList.add('lt-correct'); }); },
      hint: function () { var ts = tiles.querySelectorAll('.lt-opt'); if (spec.answer[0] != null) { ts[spec.answer[0]].classList.add('lt-focus'); setTimeout(function () { ts[spec.answer[0]].classList.remove('lt-focus'); }, 1400); } }
    };
  }

  // ── memory flash (timed reveal then pick the missing one) ──
  function stageFlash(stage, spec, submit) {
    var st = spec.stimulus;
    var flash = h('<div class="lt-flash"><div class="lt-flash-row">' + st.flashItems.map(function (el) { return '<span class="lt-cell">' + IC.renderEl(el, { px: 56 }) + '</span>'; }).join('') + '</div><div class="lt-flash-cd">' + esc(t('ui.remember')) + '</div></div>');
    stage.appendChild(flash);
    var apiHolder = {};
    setTimeout(function () {
      stage.innerHTML = '';
      var now = h('<div class="lt-flash-now"><div class="lt-flash-lbl">' + esc(t('ui.now')) + '</div><div class="lt-flash-row">' + st.nowItems.map(function (el) { return '<span class="lt-cell">' + IC.renderEl(el, { px: 48 }) + '</span>'; }).join('') + '</div></div>');
      stage.appendChild(now);
      var ask = h('<div class="lt-flash-lbl">' + esc(t('ui.which_missing')) + '</div>'); stage.appendChild(ask);
      var api = singleSelectApi2(spec, submit);
      var tiles = optionTiles(spec.options, api.pick, 56); stage.appendChild(tiles); api.tiles = tiles;
      apiHolder.hint = api.hint; apiHolder.reveal = api.reveal;
    }, st.flashMs || 1800);
    return { hint: function () { if (apiHolder.hint) apiHolder.hint(); }, reveal: function () { if (apiHolder.reveal) apiHolder.reveal(); }, markWrong: function () { } };
  }

  // ════════════════════════════ MODES ════════════════════════════
  var PRACTICE_SET = 10; // a bounded set gives a 6yo frequent wins + a clear stopping point
  function practiceHeader(skill, n, total) {
    var st = ST.skills[skill];
    var right = total
      ? '<span class="lt-phead-prog">' + n + ' / ' + total + '</span>'
      : '<span class="lt-phead-lvl">' + esc(t('ui.level')) + ' ' + st.level + '</span>';
    var bar = total ? '<div class="lt-setbar"><span style="width:' + Math.round((n - 1) / total * 100) + '%"></span></div>' : '';
    return '<div class="lt-phead"><button class="lt-link" id="ltBack">← ' + esc(t('ui.back')) + '</button>'
      + '<span class="lt-phead-skill">' + SKILL_EMOJI[skill] + ' ' + esc(t('skill.' + skill + '.name')) + '</span>'
      + right + '</div>' + bar;
  }
  function startPractice(skill) {
    curMode = 'practice'; curPuzzle = null;
    funnel('started', { skill: skill });
    ae('tool_use', { tool_slug: SLUG, skill: skill, mode: 'practice', level: ST.skills[skill].level });
    runPracticeSet(skill);
  }
  // A practice "set" = PRACTICE_SET adaptive puzzles, then a celebratory summary
  // with the option to do another. Level still adapts across sets; long-term
  // progress lives in the home skill-map bars + stars.
  function runPracticeSet(skill) {
    var idx = 0, correct = 0;
    (function step() {
      if (idx >= PRACTICE_SET) {
        ST.journey.setsDone = (ST.journey.setsDone || 0) + 1; awardBadges(); saveState();
        ae('tool_complete', { tool_slug: SLUG, mode: 'practice', skill: skill, correct: correct, total: PRACTICE_SET, level: ST.skills[skill].level });
        funnel('completed', { skill: skill });
        return summaryScreen(t('ui.set_done'), correct, PRACTICE_SET, function () { runPracticeSet(skill); });
      }
      var lvl = ST.skills[skill].level, spec;
      try { spec = E.generate(skill, lvl, seed()); } catch (e) { renderHome(); return; }
      showPuzzle(spec, practiceHeader(skill, idx + 1, PRACTICE_SET), function (outcome) {
        var res = E.nextLevel(ST.skills[skill], outcome); ST.skills[skill] = res.state;
        if (outcome !== 'failed') { ST.journey.totalCorrect++; correct++; }
        awardBadges(); saveState();
        if (res.action === 'up') { announce(t('ui.level_up')); say(t('ui.level_up_say')); playSound('levelup'); }
        idx++; step();
      });
      var back = document.getElementById('ltBack'); if (back) back.addEventListener('click', renderHome);
    })();
  }

  function startDaily() {
    curMode = 'daily'; curPuzzle = null;
    funnel('started', { skill: 'daily' });
    ae('tool_use', { tool_slug: SLUG, mode: 'daily' });
    var plan = [], prog = JSON.parse(JSON.stringify(ST.skills));
    for (var i = 0; i < 10; i++) { var sk = E.pickSkill(prog); plan.push(sk); prog[sk].attempts = (prog[sk].attempts || 0) + 1; prog[sk].mastery += 6; }
    var idx = 0, correct = 0, t0 = Date.now();
    (function step() {
      if (idx >= plan.length) {
        ST.journey.setsDone++; saveState();
        ae('tool_complete', { tool_slug: SLUG, mode: 'daily', correct: correct, total: plan.length });
        funnel('completed', { skill: 'daily' });
        return summaryScreen(t('ui.daily_done'), correct, plan.length, startDaily);
      }
      var sk = plan[idx], lvl = ST.skills[sk].level, spec;
      try { spec = E.generate(sk, lvl, seed()); } catch (e) { idx++; return step(); }
      var header = '<div class="lt-phead"><button class="lt-link" id="ltBack">← ' + esc(t('ui.back')) + '</button><span class="lt-phead-skill">⭐ ' + (idx + 1) + '/' + plan.length + '</span><span class="lt-phead-lvl">' + SKILL_EMOJI[sk] + '</span></div>';
      showPuzzle(spec, header, function (outcome) {
        var res = E.nextLevel(ST.skills[sk], outcome); ST.skills[sk] = res.state;
        if (outcome !== 'failed') { correct++; ST.journey.totalCorrect++; }
        awardBadges(); saveState(); idx++; step();
      });
      var back = document.getElementById('ltBack'); if (back) back.addEventListener('click', renderHome);
    })();
  }

  // ════════════════════════════ DIAGNOSTIC ════════════════════════════
  function startDiagnostic() {
    if (ST.age == null) return askAge(startDiagnostic);
    curMode = 'diagnostic'; curPuzzle = null;
    funnel('started', { skill: 'diagnostic' });
    ae('tool_use', { tool_slug: SLUG, mode: 'diagnostic' });
    // interleave skills, 3 items each, adaptive staircase from level 3
    var queue = [];
    for (var rep = 0; rep < 3; rep++) for (var i = 0; i < E.SKILLS.length; i++) queue.push(E.SKILLS[i]);
    // light shuffle keeping pattern/oddone early
    var results = {}; E.SKILLS.forEach(function (s) { results[s] = { level: 3, correct: 0, total: 0, _cur: 3 }; });
    var idx = 0;
    (function step() {
      if (idx >= queue.length) return finishDiagnostic(results);
      var sk = queue[idx], lvl = results[sk]._cur, spec;
      try { spec = E.generate(sk, lvl, seed()); } catch (e) { idx++; return step(); }
      var header = '<div class="lt-phead"><button class="lt-link" id="ltBack">← ' + esc(t('ui.back')) + '</button><span class="lt-phead-skill">📋 ' + (idx + 1) + '/' + queue.length + '</span></div>';
      showPuzzle(spec, header, function (outcome) {
        results[sk].total++;
        if (outcome === 'solved_unaided') { results[sk].correct++; results[sk].level = lvl; results[sk]._cur = Math.min(E.MAX_LEVEL, lvl + 2); }
        else if (outcome === 'solved_hinted') { results[sk].correct++; results[sk].level = Math.max(results[sk].level, lvl); }
        else { results[sk]._cur = Math.max(1, lvl - 2); results[sk].level = Math.max(1, Math.min(results[sk].level, lvl - 1) || 1); }
        idx++; step();
      });
      var back = document.getElementById('ltBack'); if (back) back.addEventListener('click', renderHome);
    })();
  }
  function finishDiagnostic(results) {
    var clean = {}; E.SKILLS.forEach(function (s) { clean[s] = { level: results[s].level, correct: results[s].correct, total: results[s].total }; });
    var map = E.scoreDiagnostic(clean, ST.age);
    ST.diagnostic = { done: true, map: map, ts: Date.now() };
    // seed practice levels from the diagnostic
    E.SKILLS.forEach(function (s) { ST.skills[s] = E.newSkillState(map.skills[s].estLevel); });
    saveState();
    ae('tool_complete', { tool_slug: SLUG, mode: 'diagnostic', correct: 0, total: 24 });
    funnel('completed', { skill: 'diagnostic' });
    renderReport();
  }
  function askAge(then) {
    var node = h('<div class="lt-card lg-card lt-center"><h2 class="lt-h2">' + esc(t('ui.age_question')) + '</h2>'
      + '<p class="lt-muted">' + esc(t('ui.age_hint')) + '</p><div class="lt-ages"></div>'
      + '<button class="lt-link" id="ltBack">← ' + esc(t('ui.back')) + '</button></div>');
    var ages = node.querySelector('.lt-ages');
    for (var a = 5; a <= 12; a++) { (function (age) { var b = document.createElement('button'); b.className = 'lt-btn'; b.textContent = age; b.addEventListener('click', function () { ST.age = age; saveState(); then(); }); ages.appendChild(b); })(a); }
    node.querySelector('#ltBack').addEventListener('click', renderHome);
    show(node);
  }

  // ════════════════════════════ REPORT / SKILL MAP ════════════════════════════
  function renderReport() {
    var map = (ST.diagnostic && ST.diagnostic.map) || E.scoreDiagnostic((function () { var r = {}; E.SKILLS.forEach(function (s) { r[s] = { level: ST.skills[s].level }; }); return r; })(), ST.age || 6);
    var rows = '';
    var weakFirst = E.SKILLS.slice().sort(function (a, b) { return map.skills[a].mastery - map.skills[b].mastery; });
    weakFirst.forEach(function (sk) {
      var m = map.skills[sk];
      rows += '<div class="lt-rrow lt-band-' + m.band + '">'
        + '<span class="lt-rrow-skill">' + SKILL_EMOJI[sk] + ' ' + esc(t('skill.' + sk + '.name')) + '</span>'
        + '<span class="lt-rrow-bar"><span style="width:' + m.mastery + '%"></span></span>'
        + '<span class="lt-rrow-band">' + esc(t('band.' + m.band)) + '</span>'
        + '<button class="lt-link lt-rrow-go" data-skill="' + sk + '">▶</button>'
        + '</div>';
    });
    var weak = map.weakest[0];
    var node = h('<div class="lt-report" id="ltReport">'
      + '<button class="lt-link" id="ltBack">← ' + esc(t('ui.back')) + '</button>'
      + '<h2 class="lt-h2">' + esc(t('ui.report_title')) + '</h2>'
      + '<p class="lt-report-lead">' + esc(t('ui.report_lead', { skill: t('skill.' + weak + '.name') })) + '</p>'
      + '<div class="lt-rrows">' + rows + '</div>'
      + '<div class="lt-coach lg-card"><div class="lt-coach-why">' + esc(t('why.' + weak)) + '</div><div class="lt-coach-life">🏠 ' + esc(t('coach.' + weak + '.life')) + '</div></div>'
      + '<div class="lt-controls lt-noprint">'
      + '<button class="lt-btn lt-btn-primary" id="ltPractWeak">▶ ' + esc(t('ui.practice_weak', { skill: t('skill.' + weak + '.name') })) + '</button>'
      + '<button class="lt-btn" id="ltPdf">📄 ' + esc(t('ui.print')) + '</button>'
      + '<button class="lt-btn" id="ltRetake">🔄 ' + esc(t('ui.retake')) + '</button>'
      + '</div></div>');
    node.querySelector('#ltBack').addEventListener('click', renderHome);
    node.querySelector('#ltPractWeak').addEventListener('click', function () { startPractice(weak); });
    node.querySelector('#ltRetake').addEventListener('click', function () { ST.diagnostic = { done: false }; saveState(); startDiagnostic(); });
    node.querySelector('#ltPdf').addEventListener('click', function () { exportReport(node); });
    node.querySelectorAll('.lt-rrow-go').forEach(function (b) { b.addEventListener('click', function () { startPractice(b.getAttribute('data-skill')); }); });
    show(node);
    ae('tool_interact', { tool_slug: SLUG, action: 'parent_open' });
    funnel('report');
  }
  function exportReport(node) {
    ae('tool_interact', { tool_slug: SLUG, action: 'parent_pdf' });
    if (window.__generatePDF) {
      window.__generatePDF({ element: node, filename: 'logic-skill-report.pdf', title: t('ui.report_title'), orientation: 'portrait', strings: { libError: t('ui.pdf_err'), genError: t('ui.pdf_err'), blocked: t('ui.pdf_err') } });
    } else { window.print(); }
  }

  // ════════════════════════════ SHARED UI ════════════════════════════
  function summaryScreen(title, correct, total, again) {
    var node = h('<div class="lt-card lg-card lt-center"><div class="lt-summary-emoji">🎉</div>'
      + '<h2 class="lt-h2">' + esc(title) + '</h2>'
      + '<p class="lt-summary-score">' + correct + ' / ' + total + '</p>'
      + '<div class="lt-controls"><button class="lt-btn lt-btn-primary" id="ltAgain">' + esc(t('ui.again')) + '</button>'
      + '<button class="lt-btn" id="ltHome2">' + esc(t('ui.back')) + '</button></div></div>');
    node.querySelector('#ltAgain').addEventListener('click', again);
    node.querySelector('#ltHome2').addEventListener('click', renderHome);
    show(node); say(t('ui.great_job_say')); playSound('win');
  }
  function openProfiles() {
    var node = h('<div class="lt-card lg-card"><h2 class="lt-h2">' + esc(t('ui.profile_switch_title')) + '</h2>'
      + '<div class="lt-prof-list" id="ltProfList"></div><div id="ltAddWrap"></div>'
      + '<div class="lt-controls"><button class="lt-btn" id="ltProfBack">' + esc(t('ui.back')) + '</button></div></div>');
    function refresh() {
      var list = node.querySelector('#ltProfList'); list.innerHTML = '';
      PROF.profiles.forEach(function (p) {
        var solved = (p.doc.journey && p.doc.journey.totalCorrect) || 0;
        var row = document.createElement('div'); row.className = 'lt-prof-row' + (p.id === PROF.activeId ? ' active' : '');
        row.innerHTML = '<button class="lt-prof-pick" data-id="' + p.id + '"><span class="lt-prof-av">' + esc(p.avatar) + '</span>'
          + '<span class="lt-prof-meta"><span class="lt-prof-rowname">' + esc(p.name || t('ui.player')) + '</span><span class="lt-prof-rowsub">' + solved + ' ✓</span></span></button>'
          + (PROF.profiles.length > 1 ? '<button class="lt-prof-del" data-del="' + p.id + '" aria-label="' + esc(t('ui.delete')) + '">×</button>' : '');
        list.appendChild(row);
      });
      var add = document.createElement('button'); add.className = 'lt-prof-add'; add.id = 'ltAddChild'; add.textContent = '＋ ' + t('ui.add_child');
      list.appendChild(add);
      list.querySelectorAll('.lt-prof-pick').forEach(function (b) { b.addEventListener('click', function () { switchProfile(b.getAttribute('data-id')); }); });
      list.querySelectorAll('.lt-prof-del').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); if (confirm(t('ui.delete_child_confirm'))) { deleteProfile(b.getAttribute('data-del')); refresh(); } }); });
      node.querySelector('#ltAddChild').addEventListener('click', showAdd);
    }
    function showAdd() {
      var sel = AVATARS[0], wrap = node.querySelector('#ltAddWrap');
      wrap.innerHTML = '<div class="lt-add-form"><input class="lt-name-input" id="ltNameIn" maxlength="20" placeholder="' + esc(t('ui.child_name')) + '"><div class="lt-avatars" id="ltAvatars"></div>'
        + '<div class="lt-controls"><button class="lt-btn lt-btn-primary" id="ltAddSave">' + esc(t('ui.save')) + '</button><button class="lt-btn" id="ltAddCancel">' + esc(t('ui.cancel')) + '</button></div></div>';
      var av = wrap.querySelector('#ltAvatars');
      AVATARS.forEach(function (a, i) { var b = document.createElement('button'); b.className = 'lt-av' + (i === 0 ? ' sel' : ''); b.textContent = a; b.addEventListener('click', function () { sel = a; av.querySelectorAll('.lt-av').forEach(function (x) { x.classList.remove('sel'); }); b.classList.add('sel'); }); av.appendChild(b); });
      wrap.querySelector('#ltAddSave').addEventListener('click', function () { addProfile((wrap.querySelector('#ltNameIn').value || '').trim(), sel); renderHome(); });
      wrap.querySelector('#ltAddCancel').addEventListener('click', function () { wrap.innerHTML = ''; });
    }
    node.querySelector('#ltProfBack').addEventListener('click', renderHome);
    show(node); refresh();
  }
  function openSettings() {
    var s = ST.settings;
    var node = h('<div class="lt-card lg-card"><h2 class="lt-h2">' + esc(t('ui.settings')) + '</h2>'
      + row('autoNarrate', t('ui.set_narrate'), s.autoNarrate)
      + row('sound', t('ui.set_sound'), s.sound)
      + row('parent', t('ui.set_parent'), s.parent)
      + row('dys', t('ui.set_dys'), s.dys)
      + '<div class="lt-controls"><button class="lt-btn" id="ltReset">' + esc(t('ui.reset')) + '</button>'
      + '<button class="lt-btn lt-btn-primary" id="ltDone">' + esc(t('ui.back')) + '</button></div></div>');
    function row(key, label, on) { return '<label class="lt-setrow"><span>' + esc(label) + '</span><input type="checkbox" data-k="' + key + '" ' + (on ? 'checked' : '') + '></label>'; }
    node.querySelectorAll('input[data-k]').forEach(function (inp) { inp.addEventListener('change', function () { ST.settings[inp.getAttribute('data-k')] = inp.checked; ttsOn = ST.settings.autoNarrate; applyDys(); saveState(); }); });
    node.querySelector('#ltReset').addEventListener('click', function () { if (confirm(t('ui.reset_confirm'))) { ST = defaultState(); saveState(); renderHome(); } });
    node.querySelector('#ltDone').addEventListener('click', renderHome);
    show(node);
  }
  function applyDys() { ROOT.classList.toggle('lt-dys', !!ST.settings.dys); }

  // ════════════════════════════ PRINTABLE WORKSHEET (screen-free) ════════════════════════════
  var WS_SKILLS = ['patterns', 'oddone', 'analogy', 'spatial', 'deduce', 'quantity']; // paper-friendly (MCQ)
  function openWorksheet() {
    var skill = 'mix', count = 12, withKey = false;
    var node = h('<div class="lt-card lg-card"><h2 class="lt-h2">' + esc(t('ui.ws_title')) + '</h2><p class="lt-muted">' + esc(t('ui.ws_desc')) + '</p>'
      + '<div class="lt-ws-group"><div class="lt-ws-lbl">' + esc(t('ui.your_skills')) + '</div><div class="lt-ws-row" id="ltWsSkills"></div></div>'
      + '<div class="lt-ws-group"><div class="lt-ws-lbl">' + esc(t('ui.ws_count')) + '</div><div class="lt-ws-row" id="ltWsCounts"></div></div>'
      + '<label class="lt-setrow"><span>' + esc(t('ui.ws_answers')) + '</span><input type="checkbox" id="ltWsKey"></label>'
      + '<div class="lt-controls"><button class="lt-btn lt-btn-primary" id="ltWsGo">🖨️ ' + esc(t('ui.ws_generate')) + '</button><button class="lt-btn" id="ltWsBack">' + esc(t('ui.back')) + '</button></div></div>');
    var sr = node.querySelector('#ltWsSkills');
    ['mix'].concat(WS_SKILLS).forEach(function (s) {
      var b = document.createElement('button'); b.className = 'lt-chip' + (s === skill ? ' on' : '');
      b.textContent = s === 'mix' ? t('ui.ws_mix') : (SKILL_EMOJI[s] + ' ' + t('skill.' + s + '.name'));
      b.addEventListener('click', function () { skill = s; sr.querySelectorAll('.lt-chip').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); });
      sr.appendChild(b);
    });
    var cr = node.querySelector('#ltWsCounts');
    [6, 12, 20].forEach(function (n) {
      var b = document.createElement('button'); b.className = 'lt-chip' + (n === count ? ' on' : ''); b.textContent = n;
      b.addEventListener('click', function () { count = n; cr.querySelectorAll('.lt-chip').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); });
      cr.appendChild(b);
    });
    node.querySelector('#ltWsKey').addEventListener('change', function (e) { withKey = e.target.checked; });
    node.querySelector('#ltWsGo').addEventListener('click', function () { buildWorksheet(skill, count, withKey); });
    node.querySelector('#ltWsBack').addEventListener('click', renderHome);
    show(node);
  }
  function staticStimulus(spec) {
    var st = spec.stimulus, k = st.kind;
    function c(el) { return '<span class="lt-pc">' + IC.renderEl(el, { px: 40 }) + '</span>'; }
    if (k === 'sequence') return '<div class="lt-pq-stim">' + st.items.map(c).join('') + '<span class="lt-pc lt-pc-hole">?</span></div>';
    if (k === 'analogy') return '<div class="lt-pq-stim">' + c(st.a) + '<span class="lt-pc-op">→</span>' + c(st.b) + '<span class="lt-pc-op">::</span>' + c(st.c) + '<span class="lt-pc-op">→</span><span class="lt-pc lt-pc-hole">?</span></div>';
    if (k === 'spatial') {
      if (st.mode === 'grid') { var m = ''; for (var r = 0; r < 2; r++) for (var col = 0; col < 2; col++) { var cl = st.matrix[r][col]; m += cl ? c(cl) : '<span class="lt-pc lt-pc-hole">?</span>'; } return '<div class="lt-pq-stim lt-pq-grid">' + m + '</div>'; }
      return '<div class="lt-pq-stim">' + c(st.base) + '</div>';
    }
    if (k === 'deduce') return '<div class="lt-pq-stim">' + st.clues.map(renderClue).join('') + '</div>';
    if (k === 'transitive') return '<div class="lt-pq-stim">' + st.clues.map(function (cl) { return c(st.entities[cl[0]]) + '<span class="lt-pc-op">&gt;</span>' + c(st.entities[cl[1]]); }).join('  ') + '</div>';
    return ''; // set (odd-one-out) & compare → the options ARE the stimulus
  }
  function renderStaticPuzzle(spec, num) {
    var letters = 'ABCDEF';
    var promptText = t(spec.promptKey, appPromptVars(spec));
    var opts = spec.options.map(function (o, i) { return '<span class="lt-pq-opt"><b>' + letters.charAt(i) + '</b>' + IC.renderEl(o, { px: 40 }) + '</span>'; }).join('');
    return '<div class="lt-pq"><div class="lt-pq-q">' + num + '. ' + esc(promptText) + '</div>' + staticStimulus(spec) + '<div class="lt-pq-opts">' + opts + '</div></div>';
  }
  function buildWorksheet(skill, count, withKey) {
    var ap = activeProfile();
    var pool = skill === 'mix' ? WS_SKILLS : [skill];
    var puzzles = [], guard = 0;
    while (puzzles.length < count && guard++ < count * 30) {
      var sk = pool[puzzles.length % pool.length];
      var lvl = (ST.skills[sk] && ST.skills[sk].level) || 3;
      var spec; try { spec = E.generate(sk, lvl, seed()); } catch (e) { continue; }
      if (spec.responseKind !== 'index') continue; // paper-friendly only
      puzzles.push(spec);
    }
    var body = ''; puzzles.forEach(function (spec, i) { body += renderStaticPuzzle(spec, i + 1); });
    var key = withKey ? '<div class="lt-print-key"><b>' + esc(t('ui.ws_answer_key')) + ':</b> ' + puzzles.map(function (spec, i) { return (i + 1) + '-' + 'ABCDEF'.charAt(spec.answer); }).join('   ') + '</div>' : '';
    var node = h('<div><div class="lt-controls lt-noprint" style="margin-bottom:12px"><button class="lt-btn lt-btn-primary" id="ltPrintGo">🖨️ ' + esc(t('ui.ws_print')) + '</button><button class="lt-btn" id="ltPrintBack">' + esc(t('ui.back')) + '</button></div>'
      + '<div class="lt-print" id="ltPrintArea"><div class="lt-print-head">' + esc(t('ui.ws_title')) + ' — ' + esc(ap.name || t('ui.player')) + '</div>' + body + key + '</div></div>');
    node.querySelector('#ltPrintGo').addEventListener('click', function () { try { window.print(); } catch (e) { } });
    node.querySelector('#ltPrintBack').addEventListener('click', openWorksheet);
    show(node);
    ae('feature_use', { tool_slug: SLUG, kind: 'worksheet', skill: skill, count: count });
    setTimeout(function () { try { window.print(); } catch (e) { } }, 500);
  }

  // ── gamification: badges + confetti ──
  function awardBadges() {
    var b = ST.journey.badges, have = {}; b.forEach(function (x) { have[x] = 1; });
    function add(id) { if (!have[id]) { b.push(id); have[id] = 1; ae('feature_use', { tool_slug: SLUG, kind: 'badge_earned', badge: id }); } }
    if (ST.journey.totalCorrect >= 1) add('first');
    if (ST.journey.totalCorrect >= 25) add('keen');
    if (ST.journey.totalCorrect >= 100) add('master');
    var tried = E.SKILLS.every(function (s) { return ST.skills[s].attempts > 0; }); if (tried) add('explorer');
    var three = E.SKILLS.some(function (s) { return ST.skills[s].stars >= 3; }); if (three) add('star');
  }
  function confetti(wrap) {
    if (ST.settings.reduce || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var c = document.createElement('div'); c.className = 'lt-confetti';
    for (var i = 0; i < 14; i++) { var p = document.createElement('i'); p.style.left = (10 + Math.random() * 80) + '%'; p.style.background = ['#1C6FB8', '#E5322E', '#1FA34A', '#FFC400', '#8E3FB0'][i % 5]; p.style.animationDelay = (Math.random() * 0.2) + 's'; c.appendChild(p); }
    wrap.appendChild(c); setTimeout(function () { c.remove(); }, 1200);
  }

  // ════════════════════════════ BOOT ════════════════════════════
  PROF = loadProfiles();
  ST = activeProfile().doc;
  ttsOn = ST.settings.autoNarrate;
  applyDys();
  // route: ?puzzle= deep link, ?parent= report, else home
  try {
    var q = new URLSearchParams(location.search);
    if (q.get('parent') === '1' || q.get('report') === '1') { renderReport(); }
    else if (q.get('puzzle')) {
      var d = E.decodePuzzle(q.get('puzzle'));
      if (d) { showPuzzle(E.generate(d.skill, d.level, d.seed), '<div class="lt-phead"><button class="lt-link" id="ltBack">← ' + esc(t('ui.back')) + '</button></div>', function () { renderHome(); }); var bk = document.getElementById('ltBack'); if (bk) bk.addEventListener('click', renderHome); }
      else renderHome();
    } else renderHome();
  } catch (e) { renderHome(); }
  ae('tool_interact', { tool_slug: SLUG, action: 'load' });
  syncPull(); // Pro users: pull cross-device progress (no-op otherwise)

  // Drop-off signal: if the child leaves while a puzzle is on screen mid-set.
  function flushAbandon() {
    if (curPuzzle && curPuzzle.skill) {
      ae('tool_abandon', { tool_slug: SLUG, skill: curPuzzle.skill, mode: curPuzzle.mode, answered: curPuzzle.answered || 0 });
      curPuzzle = null;
    }
    // iOS reliability: deliver the queue now (backgrounding is when iOS suspends tabs).
    try { if (window.__aeFlush) window.__aeFlush(); } catch (e) { }
  }
  try {
    window.addEventListener('pagehide', flushAbandon);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flushAbandon(); });
  } catch (e) { }
})();
